<!--
 * @Author: zxf
 * @Date: 2022-08-03 17:39:28
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 14:41:35
 * @Description: 修改原因
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-60 o-dialog--lg-50 o-dialog--xl-36"
    title="修改确认"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <el-form
      ref="fd"
      class="c-form"
      :model="fd"
      :rules="fdRules"
      :inline="true"
      label-position="right"
      label-width="0"
      label-suffix="："
    >
      <el-form-item
        class="c-form__item"
        prop="xgyy"
      >
        <el-input
          v-model="fd.xgyy"
          class="c-form__input"
          type="textarea"
          rows="10"
          placeholder="请输入重新修改原因"
        />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>
<script>
import { pgxmDetailsService } from './pgxmDetails.service';
export default {
  name: 'SqxgDialog',
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading
      dialogShow: true, // 模态框dialog显示

      fd: {
        xmId: null,
        xgyy: null
      },
      fdRules: {
        xgyy: [this.$validUtils.required('修改原因')]
      }
    };
  },
  methods: {
    /**
     * @description: 保存操作
     * @param {*}
     * @return {*}
     */
    handleSave () {
      const _this = this;
      _this.$refs.fd.validate((valid) => {
        if (valid) {
          _this.loading = true;
          pgxmDetailsService.sqxg({ xmId: _this.dlParams.id, zfyy: _this.fd.xgyy })
            .then(rsp => {
              _this.$alert('申请修改成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              _this.$emit('closeDialog', '');
              _this.$emit('callback');
            })
            .catch(err => {
              console.error('申请修改错误！', err);
            })
            .finally(() => {
              _this.loading = false;
            });
        }
      });
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  }
};
</script>
